"use strict";
angular.module("addOrEditTagServiceModule", [
    "addOrEditTagModule", //新建、编辑标签
]).
factory("addOrEditTagService", ["$modal", "$q", function($modal, $q) {
    return {
        /**
         * [addOrEditTag description] 新建、编辑标签
         * @param {[string]} [tagId,tagName] [description] 
         */
        addOrEditTag: function(tagId,tagName,channelId) {
            var deffer = $q.defer();
            var modalInstance = $modal.open({
                templateUrl: "./main/backstage/pgcManage/labelManagement/firstLevelLabel/service/addOrEditTag/addOrEditTag_tpl.html",
                windowClass: 'addOrEditTag backstageModalHeader',
                backdrop: false,
                controller: "addOrEditTagCtrl",
                resolve: {
                    tagId : function(){
                    	return tagId;
                    },
                    tagName : function(){
                    	return tagName;
                    },
                    channelId : function(){
                    	return channelId;
                    },
                }
            });
            modalInstance.result.then(function(result) {
                deffer.resolve(result);
            });
            return deffer.promise;
        }
    };
}]);